import { AdContainer } from "./ad-container";

interface AdBannerProps {
  slot?: string;
  className?: string;
}

export function AdBanner({ slot, className }: AdBannerProps) {
  return <AdContainer format="horizontal" slot={slot} className={className} />;
}
